<template>
  <b-card class="bg-transparent border-0">
    <div class="row">
      <form class="col-md-3" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
        <b-form-group :label="$t('ordemResultado.filtro.recipiente')" label-for="filter-recipient">
          <b-input id="filter-recipient" v-model="filtro.container_filter"/>
        </b-form-group>
      </form>
      <form class="col-md-3" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
        <b-form-group :label="$t('ordemResultado.filtro.vns')" label-for="filter-vns">
          <b-input id="filter-vns" v-model="filtro.vns_filter"/>
        </b-form-group>
      </form>
      <div class="col-md-3 d-flex align-items-center">
        <b-button id="btn-collapse-filters"
                  variant="link border-primary mt-3"
                  :title="$t('ordemResultado.filtro.mais_filtros')"
                  v-b-toggle.collapse-filters
                  v-b-tooltip
                  pill>
          <i class="fas fa-plus"/>
        </b-button>
      </div>
      <CountDown class="col-md-3 justify-content-center" @time-over="selectPeriod(periodo.padrao.model)"
                 @refresh="selectPeriod(periodo.padrao.model)"/>
    </div>

    <b-collapse id="collapse-filters" class="mt-2" v-model="filtro.show">
      <div class="row">
        <form class="col-md-3" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
          <b-form-group :label="$t('ordemResultado.filtro.paciente')" label-for="filter-patient">
            <b-input id="filter-patient" v-model="filtro.patient_filter"/>
          </b-form-group>
        </form>        
        <div class="col-md-9 d-flex" />
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-btn variant="link" class="align-self-center mt-3 btn-block" @click="cleanFilters">
            <i class="fas fa-search-minus"/> {{ $t('ordemResultado.filtro.limpar_button') }}
          </b-btn>
        </div>
        <div class="col-md-6">
          <b-btn id="btn-filter"
                 variant="primary"
                 class="align-self-center mt-3 btn-block"
                 @click="resetPaginator();
                 $emit('search')">
            <i class="fas fa-search"/> {{ $t('ordemResultado.filtro.filtrar_button') }}
          </b-btn>
        </div>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import {hasPerfil} from '@/acl'
import CountDown from "@/components/CountDown";
import moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ReviewObservationFilter",
  components: {
    CountDown,
    DatePicker
  },
  computed: {
    ...mapGetters({
      filtro: 'reviewObservationFilter/all'
    })    
  },
  data() {
    return {
      isVEUS: false,
      errosOptions: [
        {
          label: this.$t('ordemResultado.filtro.erros.dexpara'),
          value: '*'
        },
        {
          label: this.$t('ordemResultado.filtro.erros.exame'),
          value: 'exam_mapped_code'
        },
        {
          label: this.$t('ordemResultado.filtro.erros.material'),
          value: 'specimen_mapped_code'
        },
        {
          label: this.$t('ordemResultado.filtro.erros.metodo'),
          value: 'method_mapped_code'
        },
      ],
      periodo: {
        padrao: {
          model: {
            label: this.$t('ordemResultado.periodos.sete_dias'),
            amount: {start_date: 7, end_date: 0},
            unit: {start_date: 'days', end_date: 'minutes'},
            unitOfTime: {start_date: 'day', end_date: 'day'}
          },
          options: [
            {
              label: this.$t('ordemResultado.periodos.hoje'),
              amount: {start_date: 0, end_date: 0},
              unit: {start_date: 'minutes', end_date: 'minutes'},
              unitOfTime: {start_date: 'day', end_date: 'day'}
            },
            {
              label: this.$t('ordemResultado.periodos.sete_dias'),
              amount: {start_date: 7, end_date: 0},
              unit: {start_date: 'days', end_date: 'minutes'},
              unitOfTime: {start_date: 'day', end_date: 'day'}
            }, {
              label: this.$t('ordemResultado.periodos.mes_atual'),
              amount: {
                start_date: 0,
                end_date: 0
              },
              unit: {start_date: 'minutes', end_date: 'minutes'},
              unitOfTime: {
                start_date: 'month',
                end_date: 'month'
              }
            }, {
              label: this.$t('ordemResultado.periodos.mes_anterior'),
              amount: {start_date: 1, end_date: 1},
              unit: {start_date: 'month', end_date: 'month'},
              unitOfTime: {start_date: 'month', end_date: 'month'}
            }, {
              label: this.$t('ordemResultado.periodos.ano_atual'),
              amount: {start_date: 0, end_date: 0},
              unit: {start_date: 'minutes', end_date: 'minutes'},
              unitOfTime: {start_date: 'year', end_date: 'year'}
            }, {
              label: this.$t('ordemResultado.periodos.ano_anterior'),
              amount: {start_date: 1, end_date: 1},
              unit: {start_date: 'years', end_date: 'years'},
              unitOfTime: {start_date: 'year', end_date: 'year'}
            }
          ]
        },
        datepicker: {model: null}
      }
    }
  },
  methods: {
    ...mapActions([
      'reviewObservationFilter/setSpecific',
      'reviewObservationFilter/reset',
      'order/setPagination'
    ]),
    selectPeriod(period) {
      let start_date = moment().subtract(period.amount.start_date, period.unit.start_date)
      let end_date = moment().subtract(period.amount.end_date, period.unit.end_date)

      if (period.unitOfTime.start_date) {
        start_date = start_date.startOf(period.unitOfTime.start_date).format()
      }
      if (period.unitOfTime.end_date) {
        end_date = end_date.endOf(period.unitOfTime.end_date).format()
      }

      this['reviewObservationFilter/setSpecific']({start_date})
      this['reviewObservationFilter/setSpecific']({end_date})
      this.resetPaginator()
      this.$emit('search')
    },
    selectDatepicker(period) {
      if (period.length > 0) {
        period[0].setHours(0, 0, 0, 0)
        period[1].setHours(23, 59, 59, 999)
      }
      const start_date = moment(period[0].toUTCString()).tz("America/Sao_Paulo").format()
      const end_date = moment(period[1].toUTCString()).tz("America/Sao_Paulo").format()
      this['reviewObservationFilter/setSpecific']({start_date})
      this['reviewObservationFilter/setSpecific']({end_date})
      this.resetPaginator()
      this.$emit('search')
    },
    resetPaginator() {
      this['order/setPagination']({
        page: 1,
        per_page: 10,
        total: 0
      })
    },
    cleanFilters() {
      this['reviewObservationFilter/reset']()
      this.resetPaginator()
      this.$emit('search')
    },
    async hasPerfil(perfil) {
      try {
        return await hasPerfil(perfil)
      } catch (e) {
        return false
      }
    }
  },
  async mounted() {
    this.isVEUS = await hasPerfil('root') // todo, modificar para root ou client
  }
}
</script>

<style lang="scss" scoped>
/deep/ .mx-datepicker {
  width: 100%;
}
#collapse-filters{
  @media (max-width: 600px) {
    margin-left: 2rem!important;
    margin-right: 2rem!important;
    .ml-5, .mr-5{
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
</style>
